exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.player__jumbotron{\n    background-color: #29303B;\n    min-height: 520px;\n}\n.player__toc{\n    color: #333;\n    /* height: 520px; */\n    overflow-y: auto;\n}\n.article_area{\n    height: 100%;\n    overflow-y: auto;\n}\n", ""]);

// exports
